import axios from "axios";
import Joi from "joi";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import '../App/App.css'

export default function Register() {
  let navigate = useNavigate();
  const [errorList, setErrorList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const [user, setUser] = useState({
  
    email: "",
    password: "",
  });

  function getUser(e) {
    let myUser = { ...user };
    myUser[e.target.name] = e.target.value;
    setUser(myUser);
  
  }
  async function submitRegister(e) {
    e.preventDefault();
    setIsLoading(true);
    let validationResult = validateRegisterForm(user);
    if (validationResult.error) {
      setIsLoading(false);
      setErrorList(validationResult.error.details);
    } else {
      let { data } = await axios.post(
        "https://mrolive-back-end.onrender.com/add_admin",
        user
      );
      console.log(data.success);
      if (data.success) {
        console.log("true");
        navigate("/login");

        setIsLoading(false);
      } else {
        console.log("false");

        setError(data.message);
        setIsLoading(false);
      }
    }
  }

  function validateRegisterForm(user) {
    let schema = Joi.object({
    
      email: Joi.string()
        .email({ minDomainSegments: 2, tlds: { allow: ["com", "net"] } })
        .required(),
      password: Joi.string()
        .pattern(new RegExp(/^[a-zA-Z0-9]{3,30}$/))
        .required(),
    });
    return schema.validate(user, { abortEarly: false });
  }

  return (
    <div>
      <h1 >Register Now</h1>
      {errorList.map((error, index) => {
        if (index === 4) {
          return (
            <div key={index} className="alert alert-danger">
              {" "}
              Password required
            </div>
          );
        } else {
          return (
            <div key={index} className="alert alert-danger">
              {" "}
              {error.message}
            </div>
          );
        }
      })}

      {error ? <div className="alert alert-danger">{error}</div> : ""}
<div className="container-fluid">
<form className="py-4" onSubmit={submitRegister}>
    

    <label htmlFor="email">
      <h4>Email: </h4>{" "}
    </label>
    <input
      type="email"
      onChange={getUser}
      id="email"
      className=" my-3 form-control"
      name="email"
    />

    <label htmlFor="password">
      <h4>Password: </h4>{" "}
    </label>
    <input
      type="password"
      onChange={getUser}
      id="password"
      className=" my-3 form-control"
      name="password"
    />
    <button type="submit" className="btn btn-outline-success">
      {isLoading ? <i className="fas fa-spinner fa-spin"></i> : "Register"}{" "}
    </button>
  </form>
</div>
    
    </div>
  );
}
